export default fileString =>
  fileString.split('.').pop();
